var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.canAccessSC)?_c('v-list-item',{class:[{ mini: _vm.mini }, 'cm-hightlight-option'],attrs:{"active-class":_vm.color},on:{"click":_vm.openPortal}},[_c('v-list-item-action',{staticClass:"overwrite-margin"},[_c('v-icon',[_vm._v("mdi-road-variant")])],1),_c('v-list-item-title',[_vm._v("Safety Centre")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }